<template>
  <div
    style="
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <div style="flex: 1; display: flex; overflow: hidden">
      <c_HomeMenu :hideMenu="state.hideMenu"></c_HomeMenu>
      <div
        style="
          flex: 1;
          overflow: hidden;
          position: relative;
          display: flex;
          flex-direction: column;
        "
      >
        <c_HomeHeader
          :hideMenu="state.hideMenu"
          style="height: 60px; overflow: hidden"
          @menuToggle="state.hideMenu = !state.hideMenu"
        ></c_HomeHeader>
        <el-tabs
          v-model="$store.state.navIndex"
          :before-leave="tabBeforeHanlde"
          @tab-remove="onCloseMy"
          type="border-card"
          class="home_main_tabs"
          @tab-change="onMenuChange"
          style="flex: 1; border-left: 0; border-bottom: 0; overflow: hidden"
        >
          <template v-for="(item, index) in $store.state.navData" :key="item">
            <el-tab-pane
              style="
                height: calc(100vh - 96px);
                display: flex;
                flex-direction: column;
              "
              :closable="index != 0"
              :name="index"
              v-if="$store.state.components.includes('c_' + item.path)"
            >
              <template #label>
                <!-- <el-dropdown trigger="hover" ref="dropdownRef"> -->
                <div
                  v-if="item.path == 'HomeMain'"
                  style="display: flex; align-items: center"
                >
                  <el-icon :size="16" style="margin-top: -2px"
                    ><HomeFilled
                  /></el-icon>
                  <text
                    style="font-size: 12px; margin-left: 3px; color: inherit"
                    >{{ item.title }}</text
                  >
                </div>
                <el-dropdown v-else trigger="contextmenu">
                  <div style="display: flex; align-items: center">
                    <text style="font-size: 12px; color: inherit">
                      {{ item.title }}
                    </text>
                    <el-icon
                      @click="onReload(index)"
                      title="刷新"
                      class="is-icon-close"
                    >
                      <Refresh />
                    </el-icon>
                  </div>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item @click="onCloseOther(1, index)"
                        >关闭左侧标签</el-dropdown-item
                      >
                      <el-dropdown-item @click="onCloseOther(2, index)"
                        >关闭右侧标签</el-dropdown-item
                      >
                      <el-dropdown-item @click="onCloseOther(3, index)"
                        >关闭其他标签</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>

                <!-- <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item @click="onReload(index)">
                        <el-icon> <Refresh /> </el-icon>刷新
                      </el-dropdown-item>
                      <el-dropdown-item
                        @click="onCloseMy(index)"
                        v-if="item.path != 'HomeMain'"
                      >
                        <el-icon> <Close /> </el-icon>关闭
                      </el-dropdown-item>
                      <el-dropdown-item @click="onCloseOther(index)">
                        <el-icon> <Remove /> </el-icon>关闭其他
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template> -->
                <!-- </el-dropdown> -->
              </template>
              <!-- <ul
                style="
                  font-weight: 600;
                  font-size: 14px;
                  padding-left: 10px;
                  display: flex;
                  color: rgb(60, 60, 60);
                  margin-top: 10px;
                "
                v-if="
                  item.path.includes('List') &&
                  ![
                    'PayrollList',
                    'DeductionAmountList',
                    'EssentialList',
                    'PersonalPensionList',
                    'TaxDeclareList',
                    '1-ShuiKuanJiaoNaList',
                    'PtsMessageList',
                    'PtsCommissionList',
                    'TaxPayList',
                    'UnCalcTaxEmployeeList',
                    'ReCalcTaxEmployeeList',
                    'EmployeeList',
                    'EmployeeDeclareList',
                    'CalcTaxList',
                    'TaxDeclareEmployeeList',
                    'SalaryApplyList',
                    'SalaryRecordList',
                  ].includes(item.path)
                "
              >
                {{
                  item.title
                }}
              </ul> -->
              <div
                style="flex: 1; width: 100%; overflow: hidden"
                class="page-show"
              >
                <el-config-provider
                  :value-on-clear="null"
                  :empty-values="[undefined, null, 0]"
                >
                  <component
                    :is="'c_' + item.path"
                    :ref="(el) => setItemRef(el, 'comDom' + index)"
                    :key="item.key"
                    :data="item.data"
                  ></component
                ></el-config-provider>
              </div>
            </el-tab-pane>
            <el-tab-pane
              style="
                height: calc(100vh - 90px);
                display: flex;
                flex-direction: column;
                color: inherit;
              "
              class="page-show"
              :label="item.title"
              :closable="true"
              :name="index"
              v-else
            >
              <c_Home404></c_Home404>
            </el-tab-pane>
          </template>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, onUnmounted } from "vue";
import { admin_auth } from "@/http/admin";
import store from "@/store";

export default {
  setup() {
    const state = reactive({
      activeIndex: 0,
      oldIndex: 0,
      tabsData: [{ path: "main", title: "首页" }],
      hideMenu: false,
    });

    const comDoms = [];
    const setItemRef = (el, key) => {
      if (el) {
        comDoms[key] = el;
      }
    };

    const stopBack = () => {
      history.pushState(null, document.title, location.href);
    };
    onUnmounted(() => {
      window.removeEventListener("popstate", stopBack);
    });

    onMounted(() => {
      store.commit("onSetBrowserWidth");
      history.pushState(null, document.title, location.href);
      window.addEventListener("popstate", stopBack);
      window.addEventListener("resize", () => {
        store.commit("onSetBrowserWidth");
      });

      store.commit("onNavInit");
      state.url = window.location.origin + "/#/";
      admin_auth().then((res) => {
        if (res.status == 200) store.commit("setLoginUser", res.data.data);
      });
      // store.commit("setLoginUser", { Xm: "徐跃", BmMc: "技术部", IsGly: true });
    });

    const tabBeforeHanlde = (value, oldIndex) => {
      state.oldIndex = oldIndex;
      localStorage.setItem("navIndex", value);
    };

    //刷新当前
    const onReload = (index) => {
      // comDoms["comDom" + store.state.navIndex].onReset();
      store.commit("onRefresh", index);
    };

    //关闭当前
    const onCloseMy = (index) => {
      store.commit("onCloseMy", index);
    };

    //关闭其他
    const onCloseOther = (type, index) => {
      store.commit("onCloseOther", { type, index });
    };

    //选项卡切换事件
    const onMenuChange = (index) => {
      store.commit("onMenuChange", index);
    };

    return {
      state,
      tabBeforeHanlde,
      setItemRef,
      onReload,
      onCloseMy,
      onCloseOther,
      onMenuChange,
    };
  },
};
</script>
<style lang="less">
.home_main_tabs {
  & > .el-tabs__header {
    background-color: #fff;
    margin-bottom: -3px;

    .el-tabs__item {
      border-right-color: var(--el-border-color) !important;
    }

    .is-active {
      border-bottom: 2px solid #1e90ff !important;
      color: #1e90ff !important;

      & .el-tooltip__trigger {
        & text,
        & .el-icon {
          color: #1e90ff !important;
        }
      }
    }
  }

  & :focus-visible {
    outline: none !important;
  }

  & > .el-tabs__content {
    padding: 0;
  }
}

.home_index_toggle {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  border-bottom: 1px solid #e2e2e2;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--el-fill-color-light);
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
}

.page-show {
  animation: fadeIn 0.8s 0.02s ease backwards;
}
</style>
